import styled from 'styled-components';
import { tokens } from '../../../../../design/tokens';

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${tokens.space.sm};
`;

export const Code = styled.strong`
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.04em;
  color: ${tokens.color.textWhite};
`;

export const Muted = styled.span`
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.caption.size};
`;
